export function formatPhoneNumber(phoneNumber: string) {
  // Remove non-numeric characters (spaces, dashes, etc.)
  phoneNumber = phoneNumber.replace(/\D/g, "");

  // Validate phone number length (should be 10 digits)
  // if (phoneNumber.length !== 10) {
  //   return "Invalid phone number: Must be 10 digits.";
  // }

  // Extract area code, prefix, and line number
  const areaCode = phoneNumber.substring(0, 3);
  const prefix = phoneNumber.substring(3, 6);
  const lineNumber = phoneNumber.substring(6);

  // Format the phone number in US standard (area code in parentheses, followed by prefix and line number separated by a dash)
  return `(${areaCode}) ${prefix}-${lineNumber}`;
}
